import { CSSProperties } from 'react';

import { theme } from '@/theme';

export type ButtonType =
    | 'primary'
    | 'primary-dark'
    | 'primary-outlined'
    | 'secondary'
    | 'opposite'
    | 'danger'
    | 'danger-outlined'
    | 'success'
    | 'success-outlined'
    | 'text'
    | 'text-dark'
    | 'text-custom';

export type ButtonTextType = Extract<ButtonType, `text${string}`>;

export type ButtonDefaultType = Exclude<ButtonType, 'text-custom'>;

export type ButtonSize = 'small-x' | 'small' | 'normal';

export type ButtonWidth = 'default' | 'auto';

export interface ButtonColors {
    backgroundColor: string;
    borderColor: string;
    color: string;
    svg: { color: string };
    ':hover': {
        backgroundColor: string;
        borderColor: string;
        color: string;
    };
}

//

export const BUTTON_TEXT_TYPES: ButtonTextType[] = ['text', 'text-dark', 'text-custom'];

export const DEFAULT_ICON_SIZES: Record<ButtonSize, number> = {
    'small-x': 15,
    small: 16,
    normal: 20,
};

export const DEFAULT_SPINNER_SIZES: Record<ButtonSize, number> = {
    'small-x': 14,
    small: 16,
    normal: 18,
};

export const DEFAULT_ICON_STYLES_SIZES: Record<ButtonSize, CSSProperties> = {
    'small-x': { transform: 'translateY(-1px)' },
    small: {},
    normal: {},
};

export const DEFAULT_BUTTON_COLORS: Record<ButtonDefaultType, ButtonColors> = {
    primary: {
        backgroundColor: theme.palette.components.button,
        borderColor: theme.palette.components.button,
        color: theme.palette.common.white,
        svg: { color: theme.palette.common.white },
        ':hover': {
            backgroundColor: theme.palette.components.buttonHover,
            borderColor: theme.palette.components.buttonHover,
            color: theme.palette.common.white,
        },
    },
    'primary-dark': {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        svg: { color: theme.palette.common.white },
        ':hover': {
            backgroundColor: theme.palette.components.button,
            borderColor: theme.palette.components.button,
            color: theme.palette.common.white,
        },
    },
    'primary-outlined': {
        backgroundColor: 'transparent',
        borderColor: theme.palette.components.button,
        color: theme.palette.components.button,
        svg: { color: theme.palette.components.button },
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.components.buttonHover,
            color: theme.palette.components.buttonHover,
        },
    },
    secondary: {
        backgroundColor: theme.palette.components.buttonAlt,
        borderColor: theme.palette.components.buttonAlt,
        color: theme.palette.components.button,
        svg: { color: theme.palette.components.button },
        ':hover': {
            backgroundColor: theme.palette.components.buttonAltHover,
            borderColor: theme.palette.components.buttonHover,
            color: theme.palette.components.button,
        },
    },
    opposite: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.primary.dark,
        color: theme.palette.primary.dark,
        svg: { color: theme.palette.primary.dark },
        ':hover': {
            backgroundColor: theme.palette.background.primary,
            borderColor: theme.palette.components.buttonHover,
            color: theme.palette.primary.dark,
        },
    },
    danger: {
        backgroundColor: theme.palette.components.error,
        borderColor: theme.palette.components.error,
        color: theme.palette.common.white,
        svg: { color: theme.palette.common.white },
        ':hover': {
            backgroundColor: theme.palette.components.error,
            borderColor: theme.palette.components.error,
            color: theme.palette.common.white,
        },
    },
    'danger-outlined': {
        backgroundColor: 'transparent',
        borderColor: theme.palette.components.error,
        color: theme.palette.components.error,
        svg: { color: theme.palette.components.error },
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.components.error,
            color: theme.palette.components.error,
        },
    },
    success: {
        backgroundColor: theme.palette.statistics.green,
        borderColor: theme.palette.statistics.green,
        color: theme.palette.common.white,
        svg: { color: theme.palette.common.white },
        ':hover': {
            backgroundColor: theme.palette.statistics.green,
            borderColor: theme.palette.statistics.green,
            color: theme.palette.common.white,
        },
    },
    'success-outlined': {
        backgroundColor: 'transparent',
        borderColor: theme.palette.statistics.green,
        color: theme.palette.statistics.green,
        svg: { color: theme.palette.statistics.green },
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: theme.palette.statistics.green,
            color: theme.palette.statistics.green,
        },
    },
    text: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: theme.palette.components.button,
        svg: { color: theme.palette.components.button },
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: theme.palette.components.button,
        },
    },
    'text-dark': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: theme.palette.primary.dark,
        svg: { color: theme.palette.primary.dark },
        ':hover': {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: theme.palette.primary.dark,
        },
    },
};
